export default __webpack_public_path__ + "static/media/handphone_without_words_mobile.e17fd74d.png";